import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from "@angular/material/legacy-autocomplete";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatLegacyChipsModule as MatChipsModule } from "@angular/material/legacy-chips";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { MatLegacySnackBarModule as MatSnackBarModule } from "@angular/material/legacy-snack-bar";
import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { CalcActivityComponent } from "./activity/activity.component";
import { CustomModalPopupComponent } from "./custom-modal-popup/custom-modal-popup.component";
import { DropdownComponent } from "./dropdown/dropdown.component";
import { DropdownMultipleComponent } from "./dropdown-multiple/dropdown-multiple.component";
import { EmailFieldComponent } from "./email-field/email-field.component";
import { UrlFieldComponent } from "./url-field/url-field.component";
import { GsfCalcComponent } from "./gsf-calc/gsf-calc.component";
import { GSFReport } from "./GSF-report.service";
import { JsonService } from "./jsonService";
import { NumTextBoxComponent } from "./num-text-box/num-text-box.component";
import { PillarComponent } from "./pillar/pillar.component";
import { QuestionComponent } from "./question/question.component";
import { ActivityDependencyService } from "./service/activity-dependency.service";
import { CalculateInputFormateService } from "./service/calculate-input-formate.service";
import { CommonActivityService } from "./service/common-activity.service";
import { DuplicateCheckService } from "./service/duplicate-check.service";
import { InputValidationService } from "./service/input-validation.service";
import { ReportCalculateService } from "./service/report-calculate.service";
import { ReportDataService } from "./service/report-data.service";
import { TextBoxComponent } from "./text-box/text-box.component";
import { ToggleComponent } from "./toggle/toggle.component";
import { CategoryTypeComponent } from "./wasteReduction/category-type/category-type.component";
import { LabelComponent } from "./wasteReduction/label/label.component";
import { MaterialTypeComponent } from "./wasteReduction/material-type/material-type.component";
import { WasteReductionService } from "./wasteReduction/service/waste-reduction.service";
import { TableComponent } from "./wasteReduction/table/table.component";
import { WasteReductionComponent } from "./wasteReduction/waste-reduction/waste-reduction.component";
import { CalculatorRouting } from "./cal.routing";
import { DialogContentComponent } from "./dialog-content/dialog-content.component";
import { CheckboxComponent } from "./checkbox/checkbox-component";
import { AllowNumbersOnlyDirective } from './directives/allowNumbersOnly.directive';
import { LimitDecimalDigitsDirective } from './directives/limitDecimalDigits.directive';
import { TitleCasePipe } from "@angular/common";
export const createTranslateLoader = (http: HttpClient) => {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
};

@NgModule({
  declarations: [
    CalcActivityComponent,
    CategoryTypeComponent,
    CustomModalPopupComponent,
    DropdownComponent,
    DropdownMultipleComponent,
    EmailFieldComponent,
    UrlFieldComponent,
    GsfCalcComponent,
    LabelComponent,
    MaterialTypeComponent,
    NumTextBoxComponent,
    PillarComponent,
    QuestionComponent,
    TableComponent,
    TextBoxComponent,
    ToggleComponent,
    WasteReductionComponent,
    DialogContentComponent,
    CheckboxComponent,
    AllowNumbersOnlyDirective,
    LimitDecimalDigitsDirective
  ],

  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTabsModule,
    MatTooltipModule,
    CalculatorRouting,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],

  providers: [
    ActivityDependencyService,
    CalculateInputFormateService,
    CommonActivityService,
    DuplicateCheckService,
    GSFReport,
    InputValidationService,
    JsonService,
    ReportCalculateService,
    ReportDataService,
    WasteReductionService,
    TitleCasePipe,
  ],

  exports: [GsfCalcComponent, MatDialogModule, TranslateModule],
})
export class CalculateModule {}
